import { supplierIdFormat } from "@redotech/redo-ids/ids";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const getSupplierProductsCount = {
  name: "getSupplierProductsCount" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ totalCount: z.number().int() }),
};
